import { render, staticRenderFns } from "./HrSalaryGrant.vue?vue&type=template&id=1223b76a&scoped=true&"
import script from "./HrSalaryGrant.vue?vue&type=script&lang=js&"
export * from "./HrSalaryGrant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1223b76a",
  null
  
)

export default component.exports